import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{attrs:{"id":"duplicates-table","headers":_vm.headers,"items":_vm.duplicates},scopedSlots:_vm._u([{key:"item.view",fn:function(ref){
var item = ref.item;
return [_c(VIcon,{staticClass:"mr-2",staticStyle:{"cursor":"pointer"},on:{"click":function (_) { return _vm.viewParty(item); }}},[_vm._v(" preview ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }